import React, { useEffect, useState } from 'react';
import style from './SectionManagement.module.scss';
import {
  ButtonPrimary,
  IconBadgeAccount,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { SectionAddRoute, SectionEditBasicPath } from '../../../routes/routes';
import { SectionManagementTable } from './SectionManagementTable';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/store';
import { ISectionsState } from '../../../store/sections/store';
import { useLoadingScreen } from '../../../hooks/useLoadingScreen';
import { SectionTable } from '../../../store/sections/types';
import { SectionDelete } from './Delete/SectionDelete';

const SectionManagementList: React.FunctionComponent<{}> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { setLoading } = useLoadingScreen();
  const dispatch = useDispatch();
  const [sectionToDelete, setSectionToDelete] = useState<
    SectionTable | undefined
  >();

  const sectionsState = useSelector<StoreState, ISectionsState>(
    (state) => state.sections
  );

  useEffect(() => {
    setLoading(sectionsState.loading);
  }, [sectionsState.loading]);

  const onDeleteSection = (section: SectionTable) => {
    setSectionToDelete(section);
  };

  const onSectionDeleteClose = () => {
    setSectionToDelete(undefined);
  };

  const onSectionEditClick = (section: SectionTable) => {
    history.push(
      buildEditRoute(
        section.industry,
        section.portalName,
        section.webSectionName
      )
    );
  };

  const buildEditRoute = (
    industry: string,
    portalName: string,
    webSectionName: string
  ) => {
    return `${SectionEditBasicPath}/${industry}/${portalName}/${webSectionName}`;
  };

  return (
    <div className={`${style.sectionListContainer}`}>
      <div className={style.addSectionButtonContainer}>
        <ButtonPrimary
          className={style.addSectionButton}
          onClick={() => {
            history.push(SectionAddRoute.path);
          }}
        >
          <IconBadgeAccount />
          <a>{t('Add_Section')}</a>
        </ButtonPrimary>
      </div>
      <SectionManagementTable
        sections={sectionsState.sections}
        onDeleteClick={(section) => {
          onDeleteSection(section);
        }}
        onEditClick={(section) => onSectionEditClick(section)}
      />
      {sectionToDelete && (
        <SectionDelete
          section={sectionToDelete}
          onClose={onSectionDeleteClose}
        />
      )}
    </div>
  );
};

export default SectionManagementList;
